const MONTHS_PER_YEAR = 12;
export function localizeMonthlyToAnnual(base) {
    return deriveLocalizedDisplayPrice(base, MONTHS_PER_YEAR);
}
export function localizeAnnualToMonthly(base) {
    const monthlyFractionOfYear = 1 / MONTHS_PER_YEAR;
    return deriveLocalizedDisplayPrice(base, monthlyFractionOfYear);
}
function deriveLocalizedDisplayPrice(base, factor) {
    var _base_displayPrice_match;
    if (base.price == null) return '';
    const numeric = (_base_displayPrice_match = base.displayPrice.match(/[\d.,\u00A0\u202F ]*\d/)) === null || _base_displayPrice_match === void 0 ? void 0 : _base_displayPrice_match[0];
    if (numeric == undefined) return base.displayPrice;
    const targetAmount = base.price * factor;
    const formatted = formatAmountToMatchLocalizedSamplePrice(targetAmount, numeric);
    return base.displayPrice.replace(numeric, formatted);
}
function formatAmountToMatchLocalizedSamplePrice(amount, sample) {
    const decimalMatch = sample.match(/([.,])(\d{1,2})$/);
    var _decimalMatch_;
    const decimalSeparator = (_decimalMatch_ = decimalMatch === null || decimalMatch === void 0 ? void 0 : decimalMatch[1]) !== null && _decimalMatch_ !== void 0 ? _decimalMatch_ : '';
    var _decimalMatch__length;
    const decimalDigits = (_decimalMatch__length = decimalMatch === null || decimalMatch === void 0 ? void 0 : decimalMatch[2].length) !== null && _decimalMatch__length !== void 0 ? _decimalMatch__length : 0;
    const thousandsSeparator = detectThousandsSeparator(sample, decimalSeparator);
    const [integerPart, fractionPart] = amount.toFixed(decimalDigits).split('.');
    const groupedInteger = thousandsSeparator == '' ? integerPart : groupThousands(integerPart, thousandsSeparator);
    if (decimalDigits == 0) return groupedInteger;
    return `${groupedInteger}${decimalSeparator}${fractionPart}`;
}
function detectThousandsSeparator(sample, decimalSeparator) {
    var _sample_match;
    const separators = (_sample_match = sample.match(/[.,\u00A0\u202F ]/g)) !== null && _sample_match !== void 0 ? _sample_match : [];
    for (const separator of separators){
        if (separator != decimalSeparator) return separator;
    }
    return '';
}
function groupThousands(integerPart, thousandsSeparator) {
    return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
}
